import { ColumnType } from "antd/lib/table";
import { format } from "date-fns";
import { MdLocationOn, MdLocationOff, MdVisibility, MdEdit } from "react-icons/md";
import { SpanCultura, TalhoesInfo, ButtonView, SpanImported, Wrapper, Input } from './styles';

const columns = (
  selectedItems: string[],
  handleSelectItem: (id: string) => void,
  setIsOpenImportTalhoes: (args: boolean) => void,
  setImportTalhoesObject: (args: object) => void,
  setIdSelecao: (id: string) => void,
  setIsOpenImport: (args: boolean) => void,
): ColumnType<any>[] =>{

  let columnsShow: ColumnType<any>[] =   [
      {
        title: "Código",
        dataIndex: "codigo",
        align: "center",
        width: 80,
        render: (value: number, record: any) => (
          <Wrapper>
            <Input 
              type="checkbox"
              checked={selectedItems.includes(record.idExternoPlanoOperacional.toString())}
              onChange={() => handleSelectItem(record.idExternoPlanoOperacional.toString())}
              disabled={record.jaImportado}
            />
            <span style={{ fontWeight: "bold" }}>{value ?? "-"}</span>
          </Wrapper>
        ),
      },
      {
        title: "Descrição",
        dataIndex: "descricao",
        align: "center",
        width: 150,
        render: (value: any, _, index: number) =><span>{value ?? "-"}</span>,
      },
      {
        title: "Cultura",
        dataIndex: "cultura",
        align: "center",
        width: 100,
        render: (value: string, _, index: number) => <SpanCultura>{value ?? "-"}</SpanCultura>,
      },
      {
        title: "Operações",
        dataIndex: "operacaoQuantidade",
        align: "center",
        width: 100,
        render: (value: string, _, index: number) => <span>{value ?? "-"}</span>,
      },
     {
        title: "Talhões",
        dataIndex: "talhoes",
        align: "center",
        width: 180,
        render: (_, record: any, index: number) => {
          const countListTalhoesLogicos = record?.talhoes?.filter((talhao: any) => talhao?.talhaoId && talhao?.checked)?.length
          const countListTalhoesPlanejados = record?.talhoes?.filter((talhao: any) => !talhao?.talhaoId)?.length

        return(
          <>
            <TalhoesInfo>
                <MdLocationOn />
                <span>{countListTalhoesLogicos}</span> lógicos | <span>{countListTalhoesPlanejados}</span> planejados
            </TalhoesInfo>
              {
                !record?.edited && !record?.jaImportado && countListTalhoesLogicos > 0 && (
                  <ButtonView onClick={() => {
                      setImportTalhoesObject(record);
                      setIdSelecao(record.idExternoPlanoOperacional);
                      setIsOpenImportTalhoes(true);
                      setIsOpenImport(false);
                    }} >
                    <MdVisibility />
                    Visualizar e Confirmar
                  </ButtonView>
                )
              }
              {
                !record?.edited && record?.jaImportado && (
                  <SpanImported>
                    ✓ Já Importado
                  </SpanImported>
                )
              }
              {
                !record?.edited && !record?.jaImportado && countListTalhoesLogicos === 0 && record?.quantidadeTalhaoLogico === 0 && (
                  <ButtonView disabled>
                    <MdLocationOff />
                    Sem Talhões Lógicos
                  </ButtonView>
                )
              }
              {
                record?.edited && !record?.jaImportado && record?.quantidadeTalhaoLogico > 0 && (
                  <>
                  <SpanImported>
                    ✓ Talhões Confirmados
                  </SpanImported>
                  <ButtonView onClick={() => {
                      setImportTalhoesObject(record);
                      setIdSelecao(record.idExternoPlanoOperacional);
                      setIsOpenImportTalhoes(true);
                      setIsOpenImport(false);
                    }} >
                    <MdEdit />
                    Editar Seleção
                  </ButtonView>
                  </>
                )
              }
              </>
          )
      }
      },
      {
        title: "Data Criação",
        dataIndex: "dataAtualizacao",
        align: "center",
        width: 90,
        render: (value: string, _, index: number) =>  <span>{format(new Date(value), "dd/MM/yyyy") ?? "-"}</span>,
      },
  ];



  return columnsShow;
}
export default columns;
